<template>
  <div class="panel panel-default">
    <div class="panel-heading text-center lead mb-0">{{ versionData.versionName }}</div>
    <div class="panel-body" v-if="versionData.participantCount > 0">
      <div class="col-sm-3">
        <strong>Participants Completed:</strong> {{ versionData.participantCount }}
      </div>
      <div class="col-sm-3"><strong>Average Time to Complete:</strong> {{ avgTime }}</div>
      <div class="col-sm-3"><strong>Average Overall Score:</strong> {{ avgOverall }} points</div>
      <div class="col-sm-3">
        <strong>Results:</strong>
        <router-link
          :class="['']"
          :to="{
            name: 'participant-results',
            params: { resourceKey: versionData.versionKey },
          }"
        >
          View Full Results</router-link
        >
      </div>
    </div>
    <div class="panel-body bg-info text-center" v-else><i>No participants have completed this project.</i></div>
  </div>
</template>

<script>
  export default {
    props: {
      versionData: {
        type: Object,
        default: () => {},
      },
    },

    methods: {
      decimalCount(num) {
        const numToStr = num.toString();
        if (numToStr.includes('.')) return numToStr.split('.')[1].length;
        return 0;
      },
    },

    computed: {
      avgTime() {
        const hours = Math.floor(this.versionData.avgTime / 60);
        const minutes = this.versionData.avgTime - hours * 60;
        return hours ? `${hours}h  ${minutes}m` : `${minutes}m`;
      },
      avgOverall() {
        const decimalCount = this.decimalCount(this.versionData.avgOverall);
        return decimalCount >= 2
          ? this.versionData.avgOverall.toFixed(2)
          : this.versionData.avgOverall;
      },
    },
  };
</script>

